<!-- VERTICAL LAYOUT 1 -->
<ng-container *ngIf="rossConfig.layout.style === 'vertical-layout-1'">
    <vertical-layout-1></vertical-layout-1>
</ng-container>

<ngx-spinner
    id="spinner"
    bdColor="rgba(220,218,218,0.7)"
    size="large"
    color="#3655D8"
    type="ball-scale-ripple-multiple">
    <p style="font-size: 20px; color: #3655D8">Cargando datos...</p>
</ngx-spinner>

<ngx-spinner
    name="title-spinner"
    id="spinner"
    bdColor="rgba(220,218,218,0.7)"
    size="large"
    color="#3655D8"
    type="ball-scale-ripple-multiple">
    <p style="font-size: 20px; color: #3655D8">Actualizando Títulos Ejecutivos. Por favor espere...</p>
</ngx-spinner>
<!-- / VERTICAL LAYOUT 1 -->
